
import React from 'react';

const OrderDocumentBar = ({ 
  order, 
  onPrintTicket, 
  onPrintExchange, 
  onPrintDelivery, 
  onPrintBonDeCommande, 
  onPrintInvoice, 
  onEmailInvoice 
}) => {
  const isPending = ['pending', 'paid', 'preparing'].includes(order.lifecycleKey);
  const isTakeawayOrDelivery = ['takeaway', 'delivery'].includes(order.orderMode);

  return (
    <div className="order-doc-bar">
      <button className="order-doc-btn orange" onClick={onPrintTicket}>TICKET</button>
      <button className="order-doc-btn orange" onClick={onPrintExchange} disabled={order.refundMode !== 'avoir'}>BON D'ÉCHANGE</button>
      <button className="order-doc-btn orange" onClick={onPrintDelivery}>BON DE LIVRAISON</button>
      <button className={`order-doc-btn ${isPending && isTakeawayOrDelivery ? 'orange' : 'grey'}`} onClick={onPrintBonDeCommande} disabled={!(isPending && isTakeawayOrDelivery)}>BON DE COMMANDE</button>
      <button className="order-doc-btn yellow" onClick={onPrintInvoice}>FACTURE</button>
      <button className="order-doc-btn yellow" onClick={onEmailInvoice}>FACTURE PAR EMAIL</button>
    </div>
  );
};

export default OrderDocumentBar;
